import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const services = [
  {
    icon: "🥩",
    title: "BIO maso",
    desc: "Prodáváme smíšené 10kg balíčky hovězího vyzrálého masa — přední, zadní, kližka, guláš, žebra, kosti. Vše vakuově balené s datem spotřeby.",
  },
  {
    icon: "🐄",
    title: "Zástavová zvířata",
    desc: "Nabízíme prodej zástavových jalovic a býčků do výkrmu. Zvířata chovaná v BIO režimu s důrazem na pohodu a přirozený vývoj.",
  },
  {
    icon: "🚜",
    title: "Sečení trávy",
    desc: "Mechanizované sečení trávy na pozemcích, odvoz a manipulace s balíky sena a senáže. Rádi se domluvíme individuálně.",
  },
  {
    icon: "🌾",
    title: "Správa pozemků",
    desc: "Vaše pozemky obhospodařujeme v BIO režimu s patřičnou péčí a úctou ke generacím, které na nich pracovaly.",
  },
];

const SluzbySection: React.FC = () => {
  return (
    <Box id="sluzby" sx={{ background: "#faf5ec" }}>
    <Box sx={{ py: { xs: 6, md: 10 }, px: { xs: 2, md: 6 }, maxWidth: "950px", mx: "auto" }}>
      <Typography
        sx={{ fontSize: "13px", letterSpacing: "4px", color: "#a89858", textTransform: "uppercase", mb: 1 }}
      >
        Služby
      </Typography>
      <Typography variant="h4" component="h2" sx={{ color: "#2d2a22", fontWeight: 700, mb: 1 }}>
        Co nabízíme
      </Typography>
      <Typography sx={{ color: "#7a6a55", mb: 6, fontSize: "15px" }}>
        Individuální domluva je vždy možná. Neváhejte nás kontaktovat.
      </Typography>

      <Grid container spacing={3} sx={{ mb: 5 }}>
        {services.map((s) => (
          <Grid item xs={12} sm={6} key={s.title}>
            <Box
              sx={{
                height: "100%",
                p: 3.5,
                background: "white",
                borderRadius: "12px",
                border: "1px solid #e8d8c0",
                transition: "box-shadow 0.2s, transform 0.2s",
                "&:hover": {
                  boxShadow: "0 8px 28px rgba(90,106,64,0.12)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Typography sx={{ fontSize: "32px", mb: 1.5, lineHeight: 1 }}>{s.icon}</Typography>
              <Typography
                variant="h6"
                component="h3"
                sx={{ color: "#2d2a22", fontWeight: 700, mb: 1 }}
              >
                {s.title}
              </Typography>
              <Typography sx={{ color: "#6a5a45", fontSize: "14px", lineHeight: 1.7 }}>
                {s.desc}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* CTA banner */}
      <Box
        sx={{
          p: { xs: 3, md: 4 },
          background: "#2d2a22",
          borderRadius: "12px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { md: "center" },
          gap: 3,
          maxWidth: "860px",
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ color: "#c8b87a", fontSize: "11px", letterSpacing: "3px", textTransform: "uppercase", mb: 0.5 }}>
            Péče o pozemky
          </Typography>
          <Typography sx={{ color: "#f5edd8", fontSize: "16px", lineHeight: 1.7 }}>
            Pokud chcete, aby Vaše pozemky byly obhospodařovány v BIO režimu s patřičnou péčí a úctou,
            bude nám velkou ctí se o ně starat.
          </Typography>
        </Box>
        <Box
          component="a"
          href="#kontakt"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" });
          }}
          sx={{
            px: 3,
            py: 1.5,
            background: "#c8b87a",
            color: "#2d2a22",
            borderRadius: "6px",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            textTransform: "uppercase",
            textDecoration: "none",
            whiteSpace: "nowrap",
            transition: "background 0.15s",
            "&:hover": { background: "#d4c48a" },
          }}
        >
          Kontaktujte nás
        </Box>
      </Box>
    </Box>
    </Box>
  );
};

export default SluzbySection;
